export const Img = class {
  constructor(src, S) {
    this.src = src;
    this.S = S;
    this.El = null;
    this.ImageRatio = 1;
    this.NaturalWidth = 1000;
    this.NaturalHeight = 1000;
    this.Width = 1000;
    this.Height = 1000;
    this.AspectRatio = 1;
    this.NaturalCenter = { x: 0, y: 0 };
    this.Center = { x: 0, y: 0 };
    this.blankSvg = `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSI2MDBweCIgaGVpZ2h0PSI2MDBweCIgdmlld0JveD0iMCAwIDYwMCA2MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYwMCA2MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNFNUU1RTU7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00NzYsNzZIMTI0Yy0yNi41LDAtNDgsMjEuNS00OCw0OHYzNTJjMCwyNi41LDIxLjUsNDgsNDgsNDhoMzUyYzI2LjUsMCw0OC0yMS41LDQ4LTQ4VjEyNA0KCUM1MjQsOTcuNSw1MDIuNSw3Niw0NzYsNzZ6IE00OTIsNDc2YzAsOC44LTcuMiwxNi0xNiwxNkgxMjRjLTguOCwwLTE2LTcuMi0xNi0xNlYxMjRjMC04LjgsNy4yLTE2LDE2LTE2aDM1MmM4LjgsMCwxNiw3LjIsMTYsMTYNCglWNDc2eiBNMzk0LjgsMjMwLjdMMzI1LjUsMzAwbDY5LjMsNjkuM2M0LjcsNC43LDQuNywxMi4zLDAsMTdsLTguNSw4LjVjLTQuNyw0LjctMTIuMyw0LjctMTcsMEwzMDAsMzI1LjVsLTY5LjMsNjkuMw0KCWMtNC43LDQuNy0xMi4zLDQuNy0xNywwbC04LjUtOC41Yy00LjctNC43LTQuNy0xMi4zLDAtMTdsNjkuMy02OS4zbC02OS4zLTY5LjNjLTQuNy00LjctNC43LTEyLjMsMC0xN2w4LjUtOC41DQoJYzQuNy00LjcsMTIuMy00LjcsMTcsMGw2OS4zLDY5LjNsNjkuMy02OS4zYzQuNy00LjcsMTIuMy00LjcsMTcsMGw4LjUsOC41QzM5OS40LDIxOC40LDM5OS40LDIyNiwzOTQuOCwyMzAuN0wzOTQuOCwyMzAuN3oiLz4NCjwvc3ZnPg0K`;
    this.loadingFail = false;
  }

  get() {
    let self = this;

    self.loadingFail = false;

    return new Promise((resolve, reject) => {
      if (!self.S?.node) {
        self.loadingFail = true;
        return resolve(self);
      }

      let paperWidth = $(self.S.node).width();

      let img = new Image();
      img.setAttribute('crossorigin', 'anonymous');
      img.src = self.src;
      img.onload = (e) => {
        self.NaturalWidth = img.width;
        self.NaturalHeight = img.height;
        self.ImageRatio = img.height / img.width;
        self.AspectRatio = paperWidth < img.width ? paperWidth / img.width : 1;
        self.NaturalCenter = self.Center = { x: img.width / 2, y: img.height / 2 };

        self.Canvas = document.createElement('canvas');
        self.Canvas.width = img.width;
        self.Canvas.height = img.height;
        self.Canvas.getContext('2d').drawImage(img, 0, 0);
        self.dataUrl = self.Canvas.toDataURL('image/png');

        return resolve(self);
      };

      img.onerror = (e) => {
        self.loadingFail = true;
        self.blankImage();
        return resolve(self);
      };
    });
  }

  place({ x = 0, y = 0, w = 0, h = 0, a = 0, ratio = false } = {}) {
    ratio = ratio || this.AspectRatio;

    this.Width = Math.floor((w ? w : this.NaturalWidth) * ratio);
    this.Height = Math.floor(this.Width * this.ImageRatio);

    this.Center = { x: this.Width / 2, y: this.Height / 2 };
    this.El = this.S.image(this.dataUrl, x, y, this.Width, this.Height);
    this.El.transform(`r${a},${x + this.Center.x},${y + this.Center.y}`);
    this.El.Rotate = a;
    return this;
  }

  update(src) {
    const self = this;

    return new Promise((resolve, reject) => {
      if (!src) {
        return reject(self);
      }

      self.src = src;
      self.get().then(() => {
        self.El.attr({ href: self.dataUrl });

        resolve(self);
      });
    });
  }

  redraw({ x = 0, y = 0, w = 0, h = 0, a = 0, ratio = false } = {}) {
    let self = this;

    let paperWidth = $(self.S.node).width();
    self.AspectRatio = paperWidth < self.NaturalWidth ? paperWidth / self.NaturalWidth : 1;

    ratio = ratio || self.AspectRatio;

    self.Width = (w ? w : this.NaturalWidth) * ratio;
    self.Height = this.Width * this.ImageRatio;

    self.El.attr({ x: x, y: y, width: self.Width, height: self.Height });
  }

  blankImage() {
    let self = this;
    let paperWidth = self.S.paper.node.width.baseVal.value;

    let width = 600;
    let height = 600;

    self.src = URL.createObjectURL(new Blob([this.blankSvg], { type: 'image/svg+xml' }));
    self.NaturalWidth = width;
    self.NaturalHeight = height;
    self.ImageRatio = height / width;
    self.AspectRatio = paperWidth < width ? paperWidth / width : 1;
    self.NaturalCenter = self.Center = { x: width / 2, y: height / 2 };
    self.Canvas = null;
    self.dataUrl = this.blankSvg;
  }

  remove() {
    this.El.remove();
  }
};
